import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => {
  return {
    loginButton: {
      minWidth: 'unset',
      padding: 0
    }
  };
});

export default useStyles;
